import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import Links from './components/Links';
export function mergeLinks(linksComponents) {
  var allLinks = linksComponents.map(function (links) {
    return links.props.links;
  }).reduce(function (flatLinks, links) {
    return [].concat(_toConsumableArray(flatLinks), _toConsumableArray(links));
  }, []);
  return /*#__PURE__*/React.createElement(Links, {
    links: allLinks
  });
}